import { render, staticRenderFns } from "./chatwindow.vue?vue&type=template&id=5f7ad2c9&scoped=true"
import script from "./chatwindow.vue?vue&type=script&lang=js"
export * from "./chatwindow.vue?vue&type=script&lang=js"
import style0 from "./chatwindow.vue?vue&type=style&index=0&id=5f7ad2c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7ad2c9",
  null
  
)

export default component.exports